__turbopack_context__.v({
  "interests-modal-content": "interests-section-module-scss-module__N8ql2W__interests-modal-content",
  "interests-modal-controls": "interests-section-module-scss-module__N8ql2W__interests-modal-controls",
  "interests-modal-controls--secondary-layout": "interests-section-module-scss-module__N8ql2W__interests-modal-controls--secondary-layout",
  "interests-modal-footer": "interests-section-module-scss-module__N8ql2W__interests-modal-footer",
  "interests-modal-header": "interests-section-module-scss-module__N8ql2W__interests-modal-header",
});
